import * as React from 'react';
import { Typography, Skeleton } from '@mui/material';

interface Props {
  loading: boolean;
  content: React.ReactNode;
}

const CardRow: React.FC<Props> = ({ loading, content }: Props) => {
  return (
    <>
      {loading ? (
        <Skeleton>
          <Typography
            color="textPrimary"
            gutterBottom
            sx={(theme) => ({
              marginTop: theme.spacing(2),
              marginBottom: theme.spacing(1),
              wordBreak: 'break-word',
            })}
          >
            {content}
          </Typography>
        </Skeleton>
      ) : (
        <Typography
          color="textPrimary"
          gutterBottom
          sx={(theme) => ({
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
            wordBreak: 'break-word',
          })}
        >
          {content}
        </Typography>
      )}
    </>
  );
};

export default CardRow;
